<template>
  <div class="SvgCircle">
    <svg width="110" height="130" xmlns="http://www.w3.org/2000/svg">
      <circle
        id="backdrop"
        r="50"
        cy="65"
        cx="55"
        stroke-width="9"
        stroke="#eee"
        fill="none"
      />
      <circle
        id="progress"
        r="50"
        cy="65"
        cx="55"
        :stroke-dasharray="strokeDasharra"
        :stroke-dashoffset="strokeDashoffset"
        stroke-width="10"
        stroke="#f65846"
        fill="none"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'SvgCircle',
  data() {
    return {};
  },
  props: ['creditAmount', 'loanableAmount', 'current'],
  computed: {
    scale() {
      return 5 / 6;
    },
    strokeDashoffset() {
      return 377 * this.scale;
    },
    strokeDasharra() {
      const loanableAmount = this.loanableAmount ? this.loanableAmount : 0;
      let count = (loanableAmount / this.creditAmount || 0) * (377 * this.scale) + (377 * this.scale);
      if (count < (378 * this.scale) && count > (377 * this.scale)) {
        count = 378 * this.scale;
      }
      return count;
    }
  },
};
</script>
<style scoped>
</style>
